import { initNewsletterFunctionality } from './start-page';

export default function generalShopFunctionality() {
  customizeWlContactForm();
  initNewsletterFunctionality(false);
  initMenuHoverEffect();
  initTopBarScroll();
  initScrollHandler();
}

function customizeWlContactForm() {
  // Filuppladdning customize
  $('.wl-contact-form .wl-contact-form-image-upload-wrapper').append('<div class="choose-file-btn">Bläddra</div><div class="contact-form-file-name-container"></div>');
  $('.choose-file-btn').each(function() {
    $(this).click(function() {
      const fileInput = $(this).siblings('input').eq(0);
      fileInput.click();
      fileInput.change(function(e) {
        const fileName = e.target.files[0].name;
        $('.contact-form-file-name-container').html(fileName);
      });
    });
  });

  // selectmeny ombyggnad
  let optionsarr;
  $('.wl-contact-form-select-wrapper').each(function() {
    const parent = this;
    optionsarr = [];
    $('.wl-contact-form-select option', this).each(function() {
      optionsarr.push($(this).val());
    });
    $(this).append('<div class="fake-select-menu"><div class="select-header">' + $('.wl-contact-form-label', this).text() + '</div></div>');

    let optionsString = '<ul class="options-list">';
    optionsarr.forEach(function(option) {
      optionsString += '<li>' + option + '</li>';
    });

    optionsString += '</ul>';

    $('.fake-select-menu', this).append(optionsString);
    $('.fake-select-menu .options-list li', this).each(function() {
      $(this).click(function() {
        $('.wl-contact-form-select', parent).val($(this).text());
        $('.select-header', parent).text($(this).text());
      });
    });

    $('.fake-select-menu', this).click(function(e) {
      $('.options-list', parent).toggleClass('open');
      $('.select-header', parent).toggleClass('open');
    });
  });
}

// Hover meny
function initMenuHoverEffect() {
  const menus = ['.primary-menu__nav .menu', '.secondary-menu__nav .menu'];
  const submenuContainer = document.getElementById('detached-submenu-container');
  const body = document.body;

  if (!submenuContainer) return;

  menus.forEach(function (menuSelector) {
    const menuItems = document.querySelectorAll(`${menuSelector} > li`);

    menuItems.forEach(function (menuItem) {
      const subMenu = menuItem.querySelector('.sub-menu');

      if (subMenu && !menuItem.dataset.processed) {
        menuItem.dataset.processed = 'true';

        const subMenuWrapper = document.createElement('div');
        subMenuWrapper.classList.add('detached-submenu');
        subMenuWrapper.dataset.parentId = menuItem.id;
        subMenuWrapper.appendChild(subMenu);
        submenuContainer.appendChild(subMenuWrapper);
      }

      menuItem.addEventListener('mouseenter', function () {
        closeAllMenus();

        menuItem.classList.add('active');

        const detachedSubMenu = submenuContainer.querySelector(`.detached-submenu[data-parent-id='${menuItem.id}']`);

        if (detachedSubMenu) {
          const rect = menuItem.getBoundingClientRect();
          detachedSubMenu.classList.add('visible');
          detachedSubMenu.classList.remove('hidden');
          detachedSubMenu.style.top = `${rect.bottom}px`;
          detachedSubMenu.style.left = '0';
          detachedSubMenu.style.width = '100vw';
        }

        menuItems.forEach(item => {
          if (item !== menuItem) {
            item.classList.add('inactive');
          }
        });

        body.classList.add('no-scroll');

        setTimeout(() => {
          submenuContainer.classList.add('disable-transition');
        }, 300);
      });

      menuItem.addEventListener('mouseleave', function () {
        setTimeout(() => {
          if (!submenuContainer.matches(':hover') && !menuItem.matches(':hover')) {
            closeAllMenus();
          }
        }, 150);
      });
    });

    submenuContainer.addEventListener('mouseleave', closeAllMenus);
  });

  function closeAllMenus() {
    submenuContainer.querySelectorAll('.detached-submenu').forEach(subMenu => {
      subMenu.classList.remove('visible');
      subMenu.classList.add('hidden');
      body.classList.remove('no-scroll');
    });

    document.querySelectorAll('.menu-item').forEach(menuItem => {
      menuItem.classList.remove('active', 'inactive');
    });

    setTimeout(() => {
      const maybeVisibleMenus = submenuContainer.querySelectorAll('.detached-submenu.visible');
      if (maybeVisibleMenus.length === 0) {
        submenuContainer.classList.remove('disable-transition');
      }
    }, 3000);
  }
}

// Top bar animation
function initTopBarScroll() {
  const track = document.querySelector('.top-bar__track');
  const items = document.querySelectorAll('.top-bar__item');

  if (!track || items.length === 0) {
    console.warn('Top-bar track or items not found.');
    return;
  }

  let contentWidth = Array.from(items).reduce((width, item) => width + item.offsetWidth, 0);

  while (contentWidth < track.offsetWidth * 2) {
    items.forEach(item => {
      const clone = item.cloneNode(true);
      track.appendChild(clone);
    });
    contentWidth = Array.from(track.children).reduce((width, item) => width + item.offsetWidth, 0);
  }

  let position = 0;
  const scrollSpeed = window.innerWidth > 768 ? 1.2 : 0.7;

  function animate() {
    position -= scrollSpeed;

    if (Math.abs(position) >= contentWidth / 2) {
      position = 0;
    }

    track.style.transform = `translateX(${position}px)`;
    requestAnimationFrame(animate);
  }

  animate();
}

function initScrollHandler() {
  let scrollClassAdded = false;
  function handleScroll() {
    const scrollTop = $(window).scrollTop();

    const hasTopBar = $('.top-bar').length > 0;
    if (hasTopBar && scrollTop === 0) {
      $('body').addClass('top-bar-body');
    } else {
      $('body').removeClass('top-bar-body');
    }

    if (scrollTop > 0 && !scrollClassAdded) {
      $('body').addClass('scrolled');
      scrollClassAdded = true;
    } else if (scrollTop === 0 && scrollClassAdded) {
      $('body').removeClass('scrolled');
      scrollClassAdded = false;
    }
  }

  $(document).ready(function () {
    handleScroll();
    $(window).on('scroll', handleScroll);
  });
}
